import { Switch, Text } from '@byecode/ui'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import type { FC } from 'react'

import { listCommonStyles } from './constants'

interface EditableProps {
    value?: boolean
    disabled?: boolean

    onChange?: (v: boolean) => void
}

export const Editable: FC<EditableProps> = ({ value, disabled, onChange }) => (
    <ListItem4ByecodeUi styles={listCommonStyles} enableHover={!disabled} justifyContent="space-between" alignItems="center">
        <Text>允许编辑</Text>
        <Switch checked={value} onChange={e => onChange?.(e.currentTarget.checked)} />
    </ListItem4ByecodeUi>
)
